module.exports = __webpack_public_path__ + "img/vrleft.65f2a253.png";